function renderQuickView(URL, el, quickview_product) {
	var tmpl_clean = quickview_product.find('.js-quickview-clean');
	// Reset Quickview
	quickview_product.find('[data-product-price-old]').addClass('d-none');
	tmpl_clean.empty();
	el.find('[data-add-to-cart-text]').addClass('d-none');
	el.find('[data-loader]').removeClass('d-none');
    $('a[js-button-quickview-message]').removeClass('d-none');
	// Get information product
	$.getJSON(URL +'.js', function(product) {
		let iProductCurrent = product.id;
		let iProductTitle = product.title;
		let iProductVendor = product.vendor;
		let iProductUrl = product.url;
		let iProductImage = "url('" + product.featured_image + "&width=780')";
		let iProductPrice = product.price / 100;
		let iProductVariants = product.variants;
		let iProductOptions = product.options;
		let iProductAvailable = product.available;
		let iOptionNameHTML = '';
		// Get variants
		if ( iProductOptions.length >= 1 ) {
			for(let i = 0; i < iProductOptions.length; i++){
				let iOptionsHTML = '';
				let iOption = '';
				if ( iProductVariants.length >= 1 ) {
					for(let y = 0; y < iProductVariants.length; y++){
						var iProductVariantsAvailable = (iProductVariants[y].available === true )? '' : 'disabled';
						iOption = '<div class="c-quick-view-product__variant ' + iProductVariantsAvailable + ' js-quickview-get-variant" data-position="'+ iProductOptions[i].position +'" data-value="'+ iProductVariants[y].title +'" data-product-id="'+ iProductUrl +'"><span data-size_crocs="'+ iProductVariants[y].title + '" class="js-quick-change-size-label s-quickview__value">' + iProductVariants[y].title + '</span></div>';
						iOptionsHTML = iOptionsHTML + iOption;
						// First variant - Set price
						if (y == 0) {
							priceVariantsSelect(iProductVariants[0], quickview_product);
						}
					}
					// Render variants
					let iItemsHTML = '<div class="c-quick-view-product__variants-wrapper s-quickview__items--' + iProductOptions[i].name + ' mb-p15">' +
										iOptionsHTML +
									'</div>';
					iOptionNameHTML = iOptionNameHTML +  iItemsHTML;
				}
			}
		}
		// Template
		quickview_product.find('[js-quickview-message]').removeClass('active');
		quickview_product.find('[data-product-title]').append(iProductTitle);
		quickview_product.find('[data-product-vendor]').append(iProductVendor);
		quickview_product.find('[data-product-thumb]').append('<div class="c-quick-view-product__thumb-image" style="background: white '+ iProductImage +'no-repeat center center; background-size: cover;" role="img" aria-label="'+ iProductTitle +'"></div>');
		quickview_product.find('[data-product-options]').append(iOptionNameHTML);
		quickview_product.addClass('active');
		el.find('[data-add-to-cart-text]').removeClass('d-none');
		el.find('[data-loader]').addClass('d-none');
	});
}

function renderVariantColor(variantColor, quickview_product) {
	var dataProduct = JSON.parse(variantColor);
	let iOptionNameHTMLColor = '';
	let iOptionsHTML = '';
	let iOption = '';
	for(let y = 0; y < dataProduct.length; y++){
		iOption = '<div class="c-quick-view-product__variant-color js-quickview-change-color" data-product-url="'+ dataProduct[y].url +'">' +
						'<a href="'+ dataProduct[y].url +'" class="c-quick-view-product__variants-color-link ">' +
							'<div class="c-quick-view-product__variants-color-item" style="background: url('+ dataProduct[y].image +') center center no-repeat; background-size: 2000%;"></div>' +
						'</a>' +
					'</div>';
		iOptionsHTML = iOptionsHTML + iOption;
	}
	let iItemsHTML = '<div class="c-quick-view-product__variants-color-wrapper mb-p15">' +
						iOptionsHTML +
					'</div>';
	iOptionNameHTMLColor = iOptionNameHTMLColor +  iItemsHTML;
	quickview_product.find('[data-product-variants-colors]').append(iOptionNameHTMLColor);
	quickview_product.find('.js-quickview-color-label').removeClass('d-none');
}

function urlSplit(url) {
	let url_short
	if (url.includes('?')) {
		let urlsplit = url.split('?');
		return url_short = urlsplit[0];
	}else{
		return url_short = url;
	}
}

function priceVariantsSelect(product_variant, quickview_product) {
    let iVariantFirst = product_variant.id;
    let iVariantFirstTitle = product_variant.title;
    let iVariantFirstComparePrice = product_variant.compare_at_price;
    let iVariantFirstPrice = product_variant.price;
    quickview_product.find('[data-product-price]').empty().append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(iVariantFirstPrice/100));
    // Discounts
    if (iVariantFirstComparePrice > iVariantFirstPrice) {
        quickview_product.find('[data-product-price-old]').removeClass('d-none').empty().append(new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(iVariantFirstComparePrice/100));
    }else{
        quickview_product.find('[data-product-price-old]').addClass('d-none');
    }
    quickview_product.find('.js-btn-card-quickview').attr('data-product-variant-id', iVariantFirst);
}

document.addEventListener('DOMContentLoaded', () => {
	/* Open quick view */
	/* -------------------------------------------------------------------------------------- */
	$('body').on('click', '.js-quickview-product', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_url = el.attr('data-product-url');
		var url_new = urlSplit(product_url);
		var quickview_product = $('#quickviewProduct');
		quickview_product.find('.js-quickview-clean-color').empty();
		quickview_product.find('.js-quickview-color-label').addClass('d-none');
		// Render product information
		renderQuickView(url_new, el, quickview_product);
		// Variant color
		var metafieldJson = el.closest('[js-product-card-buttons]').find('#variantColor').val();
		if (metafieldJson) renderVariantColor(metafieldJson, quickview_product);
	});

	/* QuickView - Select variant */
	/* -------------------------------------------------------------------------------------- */
	$('#quickviewProduct').on('click', '.js-quickview-get-variant', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this),
			idProduct = el.attr('data-product-id'),
			listVariants = $('.js-quickview-get-variant'),
			quickview_product = $('#quickviewProduct');
		if (el.hasClass('disabled')) {
			quickview_product.find('[js-quickview-message]').addClass('active');
			quickview_product.find('[text-message-warning]').empty().text('LA TALLA NO ESTA DISPONIBLE');
		}else {
			// Reset variants
			el.addClass('active');
			el.siblings('.js-quickview-get-variant').removeClass('active');
			quickview_product.find('[js-quickview-message]').removeClass('active');
			quickview_product.find('[text-message-warning]').empty();
			// Variant to look for 
			var option = [];
			for (var i = 0; i < listVariants.length; i++) {
				if ($(listVariants[i]).hasClass('active')) {
					var position = $(listVariants[i]).attr('data-position');
					for (var j = 1; j < listVariants.length; ++j) {
						if (position == j) {
							option[j] = $(listVariants[i]).attr('data-value');
						}
					}
				}
			}
			// Get information product
			$.getJSON(idProduct+'.js', function(product) {
				var iProductVariants = product.variants;
				var iProductUrl = product.url;
				// Search for matches in product options
				var currentVariant = _.find(iProductVariants, function (o) {
					return o.option1 == option[1] && o.option2 == option[2] && o.option3 == option[3];
				});
				// Options not found
				if (currentVariant === undefined) {
					quickview_product.find('[text-message-warning]').empty().text('TALLA NO ENCONTRADA');
				}else {
					// Enable or disabled buttons
					var qVariantAvailable = currentVariant.available;
					if (qVariantAvailable == true) {
						priceVariantsSelect(currentVariant, quickview_product);
					}
                    var selectVariant = $('#quickviewProduct .js-quickview-get-variant').hasClass('active');
					var selectMessage = $('#quickviewProduct a[js-button-quickview-message]').hasClass('d-none');
					if (selectVariant == true && selectMessage == false) {
						$('a[js-button-quickview-message]').addClass('d-none');
					}
				}
			});
		}
	});
	/* QuickView - Messagge SIZES */
	/* -------------------------------------------------------------------------------------- */
	$('#quickviewProduct').on('click', '[js-button-quickview-message]', function(event) {
		event.preventDefault();
		/* Act on the event */
		var el = $(this);
		el.closest('#quickviewProduct').find('[js-quickview-message]').addClass('active');
		el.closest('#quickviewProduct').find('[text-message-warning]').empty().text('POR FAVOR SELECCIONA UNA TALLA');
	});
	/* QuickView - Select variant */
	/* -------------------------------------------------------------------------------------- */
	$('#quickviewProduct').on('click', '.js-quickview-change-color', function(event) {
		event.preventDefault();
		event.stopPropagation();
		var el = $(this);
		var product_url = el.attr('data-product-url');
		var url_new = urlSplit(product_url);
		var quickview_product = $('#quickviewProduct');
		// Render product information
		renderQuickView(url_new, el, quickview_product);
	});
});